import { render, staticRenderFns } from "./RiskConferenceWarningAlwaysUpdate.vue?vue&type=template&id=edd4b570&scoped=true&"
import script from "./RiskConferenceWarningAlwaysUpdate.vue?vue&type=script&lang=js&"
export * from "./RiskConferenceWarningAlwaysUpdate.vue?vue&type=script&lang=js&"
import style0 from "./RiskConferenceWarningAlwaysUpdate.vue?vue&type=style&index=0&id=edd4b570&prod&scoped=true&lang=css&"
import style1 from "./RiskConferenceWarningAlwaysUpdate.vue?vue&type=style&index=1&id=edd4b570&prod&lang=scss&scoped=true&"
import style2 from "./RiskConferenceWarningAlwaysUpdate.vue?vue&type=style&index=2&id=edd4b570&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edd4b570",
  null
  
)

export default component.exports